import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { creditLineFormFields } from './line-form-fields.js';
import { refineCreditLineForm } from './refine-credit-line-form.js';
// A blank or missing id is a line the edit adds; a stored line keeps its id so it is updated in place.
export const promotionCreditLineUpdateFormSchema = z
    .object({
    id: optionalUuidString('Invalid credit line.').optional(),
    ...creditLineFormFields,
})
    .superRefine(refineCreditLineForm);
//# sourceMappingURL=line-update-form.js.map